import Responses from "../components/responses/index";

const ResponseRoutes = [
  {
    path: "/responses",
    component: Responses,
    exact: true,
  }
  // going to route to CustomerResponses component instead
];

export default ResponseRoutes;
